/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Audit_Event_Deal_Rejected13Inputs */

const en_coinvestments_audit_event_deal_rejected13 = /** @type {(inputs: Coinvestments_Audit_Event_Deal_Rejected13Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal Rejected`)
};

/**
* | output |
* | --- |
* | "Deal Rejected" |
*
* @param {Coinvestments_Audit_Event_Deal_Rejected13Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_audit_event_deal_rejected13 = /** @type {((inputs?: Coinvestments_Audit_Event_Deal_Rejected13Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Audit_Event_Deal_Rejected13Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_audit_event_deal_rejected13(inputs)
});
export { coinvestments_audit_event_deal_rejected13 as "coInvestments_audit_event_DEAL_REJECTED" }